/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { FormulaMapper } from '../common';
import { FormulaCalculationDto } from './formula.dto';

export const FormulaCalculationMapper = entity<FormulaCalculationDto>({
  formula: FormulaMapper,
});
